import { ScheduleExpectation } from '@/types/scheduleExpectation';

// Custom expectations created by sequences (future appointment requests, starters)
// are expected deviations, so only flag ones staff created directly.
const isStandaloneCustomExpectation = (expectation: ScheduleExpectation | null): boolean =>
  !!expectation?.custom_schedule_expectation_id && !expectation.sequence_id;

export default isStandaloneCustomExpectation;
